<template>
  <div class="main-content">
    <div class="card p-3">
      <div class="page-head">
        <div class="page-title-big">Modelos de Flow</div>
        <button class="btn btn-primary btn-sm top-btn" @click="goNew">
          <span class="btn-label">Novo modelo</span>
        </button>
      </div>

      <div class="filters-box">
        <div class="filters-row">
          <input
            v-model="search"
            class="form-control"
            placeholder="Buscar por título ou tag..."
            @keyup.enter="load"
          />
          <button class="btn btn-primary btn-filter" @click="load">
            Buscar
          </button>
          <button class="btn btn-light btn-filter" @click="clearSearch">
            Limpar
          </button>
        </div>
      </div>

      <div v-if="error" class="alert alert-danger mt-2">{{ error }}</div>

      <div class="table-shell mt-3">
        <div v-if="loading" class="empty-row">Carregando...</div>
        <div v-else class="table-responsive">
          <table class="table table-sm table-bordered my-table">
            <thead>
              <tr>
                <th class="col-id">ID</th>
                <th>TÍTULO</th>
                <th>TAG</th>
                <th class="col-num">Nº ETAPAS</th>
                <th class="col-open">CRIADO EM</th>
                <th class="actions-th col-actions">AÇÕES</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="tpl in rows" :key="tpl.id">
                <td class="id-cell">
                  <b>#{{ tpl.id }}</b>
                </td>
                <td>{{ tpl.title }}</td>
                <td>{{ tpl.tag || "—" }}</td>
                <td class="text-center">
                  {{ (tpl.transitions || []).length }}
                </td>
                <td>{{ formatDate(tpl.created_at) }}</td>
                <td class="actions-td">
                  <div class="actions">
                    <button
                      class="icon-btn btn-edit"
                      title="Editar"
                      @click="edit(tpl)"
                    >
                      <i class="fa fa-pencil"></i>
                    </button>
                    <button
                      class="icon-btn btn-del"
                      title="Excluir"
                      @click="confirmDelete(tpl)"
                    >
                      <i class="fa fa-trash"></i>
                    </button>
                  </div>
                </td>
              </tr>
              <tr v-if="!rows.length">
                <td colspan="6" class="empty-row">Nenhum modelo encontrado.</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <!-- Paginação -->
      <div v-if="lastPage > 1" class="pagination-row mt-2">
        <button
          class="btn btn-sm btn-light"
          :disabled="currentPage <= 1"
          @click="changePage(currentPage - 1)"
        >
          ‹
        </button>
        <span class="page-info">{{ currentPage }} / {{ lastPage }}</span>
        <button
          class="btn btn-sm btn-light"
          :disabled="currentPage >= lastPage"
          @click="changePage(currentPage + 1)"
        >
          ›
        </button>
      </div>
    </div>

    <!-- Modal de confirmação de exclusão -->
    <div
      v-if="deleteTarget"
      class="modal-mask"
      @click.self="deleteTarget = null"
    >
      <div class="modal-card">
        <div class="modal-head">
          <div class="modal-title">Confirmar exclusão</div>
          <button class="modal-x" @click="deleteTarget = null">×</button>
        </div>
        <div class="modal-body">
          Deseja excluir o modelo <strong>{{ deleteTarget.title }}</strong
          >? Esta ação não pode ser desfeita.
        </div>
        <div class="modal-foot">
          <button
            class="btn btn-outline-secondary"
            @click="deleteTarget = null"
          >
            Cancelar
          </button>
          <button class="btn btn-danger" @click="doDelete">Excluir</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      rows: [],
      loading: false,
      error: "",
      search: "",
      currentPage: 1,
      lastPage: 1,
      deleteTarget: null,
    };
  },

  async mounted() {
    await this.load();
  },

  methods: {
    async load() {
      this.loading = true;
      this.error = "";
      try {
        const apiBase = this.$store.state.api;
        const res = await this.$http.get(apiBase + "flow-templates", {
          params: {
            search: this.search || undefined,
            page: this.currentPage,
          },
        });
        const raw = res.data;
        this.rows = raw.data || raw;
        this.lastPage = raw.last_page || 1;
      } catch (e) {
        this.error = "Erro ao carregar modelos.";
        console.error(e);
      } finally {
        this.loading = false;
      }
    },

    clearSearch() {
      this.search = "";
      this.currentPage = 1;
      this.load();
    },

    changePage(page) {
      this.currentPage = page;
      this.load();
    },

    goNew() {
      this.$router.push("/Flow/templates/new");
    },

    edit(tpl) {
      this.$router.push("/Flow/templates/edit/" + tpl.id);
    },

    confirmDelete(tpl) {
      this.deleteTarget = tpl;
    },

    async doDelete() {
      if (!this.deleteTarget) return;
      try {
        const apiBase = this.$store.state.api;
        await this.$http.delete(
          apiBase + "flow-templates/" + this.deleteTarget.id
        );
        this.deleteTarget = null;
        await this.load();
      } catch (e) {
        this.error = "Erro ao excluir o modelo.";
        this.deleteTarget = null;
        console.error(e);
      }
    },

    formatDate(val) {
      if (!val) return "—";
      const d = new Date(val);
      return d.toLocaleDateString("pt-BR");
    },
  },
};
</script>

<style scoped>
.page-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 16px;
}
.page-title-big {
  font-size: 20px;
  font-weight: 800;
  color: #111827;
}
.filters-box {
  margin-bottom: 12px;
}
.filters-row {
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
  align-items: center;
}
.filters-row .form-control {
  flex: 1;
  min-width: 200px;
  height: 36px;
}
.btn-filter {
  height: 36px;
}
.top-btn {
  height: 36px;
}
.table-shell {
  overflow: hidden;
}
.my-table th {
  font-size: 11px;
  font-weight: 800;
  color: #6b7280;
  background: #f9fafb;
  white-space: nowrap;
}
.col-id {
  width: 60px;
}
.col-num {
  width: 100px;
  text-align: center;
}
.col-open {
  width: 120px;
}
.col-actions {
  width: 90px;
}
.id-cell {
  font-weight: 700;
  color: #374151;
}
.empty-row {
  text-align: center;
  padding: 20px;
  color: #9ca3af;
  font-style: italic;
}
.actions {
  display: flex;
  gap: 6px;
  justify-content: center;
}
.icon-btn {
  width: 30px;
  height: 30px;
  border-radius: 8px;
  border: 1px solid #e5e7eb;
  background: #fff;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 13px;
}
.btn-edit {
  color: #2563eb;
}
.btn-edit:hover {
  background: #eff6ff;
  border-color: #93c5fd;
}
.btn-del {
  color: #dc2626;
}
.btn-del:hover {
  background: #fef2f2;
  border-color: #fca5a5;
}
.pagination-row {
  display: flex;
  align-items: center;
  gap: 8px;
  justify-content: flex-end;
}
.page-info {
  font-size: 13px;
  color: #6b7280;
}
/* Modal */
.modal-mask {
  position: fixed;
  inset: 0;
  background: rgba(17, 24, 39, 0.35);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
  padding: 18px;
}
.modal-card {
  width: 480px;
  max-width: 95vw;
  background: #fff;
  border-radius: 12px;
  border: 1px solid #e5e7eb;
  box-shadow: 0 16px 60px rgba(0, 0, 0, 0.18);
}
.modal-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 14px 16px;
  border-bottom: 1px solid #eef2f7;
}
.modal-title {
  font-weight: 900;
  color: #111827;
}
.modal-x {
  border: 0;
  background: transparent;
  font-size: 22px;
  font-weight: 900;
  color: #6b7280;
  cursor: pointer;
}
.modal-body {
  padding: 16px;
  color: #374151;
}
.modal-foot {
  padding: 14px 16px;
  border-top: 1px solid #eef2f7;
  display: flex;
  justify-content: flex-end;
  gap: 10px;
}
</style>
